<div [formGroup]="form">
  <div class="date-from">
    <label for="dfrom">Date from <span [ngStyle]="{'color': 'maroon'}">(required)</span></label>
    <lib-date-picker #fromDatePicker isFromDate="true" ></lib-date-picker>
    <div class="help-block">
      <span *ngIf="form.get('datefrom')?.get('datebox')?.errors?.required && form.get('datefrom')?.get('datebox')?.touched">Enter Date from; use mm/dd/yyyy format</span>
      <span *ngIf="form.errors?.fromdatefuture && form.get('datefrom')?.get('datebox')?.touched">Date from cannot be future date</span>
    </div>

  </div>
  <div class="space">

  </div>
  <div class="date-to">
    <label for="dto">Through date <span [ngStyle]="{'color': 'maroon'}">(required)</span></label>
    <lib-date-picker #toDatePicker ></lib-date-picker>
    <div class="help-block">
      <span *ngIf="form.get('dateto')?.get('datebox')?.errors?.required && form.get('dateto')?.get('datebox')?.touched">Enter Date to; use mm/dd/yyyy format</span>
      <span *ngIf="form.errors?.datecompare && form.get('dateto')?.get('datebox')?.touched">Date from cannot be greater than through date</span>
      <!--<span class="help-block"
    *ngIf="form.errors?.todatefuture && form.get('dateto').touched">Date to is future date.</span>-->
    </div>

  </div>
</div>
